import builder from '../builder';
import Delete2 from '../../streamline-icons/bold/delete-2.svg';

export default builder('IconDelete2Bold', Delete2);
